import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-list\">\n<g id=\"icon-list_Menu/list\">\n<g id=\"icon-list_view-list\">\n<path d=\"M14 4.5H2V3.5H14V4.5Z\" fill=\"#282C33\" />\n<path d=\"M14 8.5H2V7.5H14V8.5Z\" fill=\"#282C33\" />\n<path d=\"M2 12.5H14V11.5H2V12.5Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list.svg
// module id = vuHp
// module chunks = 140